import React from 'react'
import Link from './Link'
import Image from './Image'
import Headline from './Headline'

const LayeredTeaser = ({ item }) => {
  return (
    <section
      data-rellax-center={true}
      data-rellax-speed={1}
      className="layered-teaser-item"
    >
      <article>
        <Link link={item.link}>
          <div className="layered-teaser-item-wrapper">
            <div className="layered-teaser-item-image">
              <Image
                image={item.image}
                alt={item.alt}
                imageWidth="546"
                imageHeight="410"
              />
            </div>
            <div className="layered-teaser-item-content">
              <Headline
                kicker={item.kicker}
                headline={item.headline}
                subheadline={item.subheadline}
              />
              {item.text?.length > 0 && (
                <p className="layered-teaser-item-text">{item.text}</p>
              )}
              {item.link_text?.length > 0 && (
                <span className="pseudo-link">
                  {item.link_text} <i className="fas fa-angle-right"></i>
                </span>
              )}
              {item.meta_info?.length > 0 && (
                <div className="meta-info">{item.meta_info}</div>
              )}
            </div>
          </div>
        </Link>
      </article>
    </section>
  )
}

export default LayeredTeaser
